import { useOnMount, useOnUnmount } from '@prophecy/utils/react/hooks';
import { useRef } from 'react';

import { useGlobalVariables } from '../context/globalConfig/securedConfigHook';

const URL = `${window.location.origin}/athena/api/v1/ws`;

export default function useWebsocketLogs() {
  const socket = useRef<WebSocket>();

  function closeWebSocket() {
    if (socket.current?.readyState === WebSocket.OPEN) {
      socket.current?.close(); // Close the WebSocket connection
      console.log('WebSocket connection has been closed.');
    } else {
      console.log('WebSocket connection is already closed or not open yet.');
    }
  }

  const isWebsocketDebugEnabled = useIsWebsocketDebugEnabled();

  useOnMount(() => {
    if (!isWebsocketDebugEnabled) {
      return;
    }

    socket.current = new WebSocket(URL);

    socket.current.addEventListener('open', () => {
      console.log('WebSocket connection established!');
    });

    socket.current.addEventListener('message', (event) => {
      console.log('ws:', event.data);
    });

    socket.current.addEventListener('close', () => {
      console.log('WebSocket connection closed', URL);
    });

    socket.current.addEventListener('error', (event) => {
      console.error('WebSocket error:', event);
    });
  });

  useOnUnmount(() => {
    closeWebSocket();
  });
}

export function useIsWebsocketDebugEnabled() {
  const globalConfig = useGlobalVariables();
  return globalConfig.isWebsocketDebugEnabled;
}
